<app-dialog
  #dialog
  [key]="'committee-vote'"
  [action]="'committee-vote'"
  [headerTheme]="'simple'"
  [maxWidth]="'480px'"
  [hideDefaultFooter]="true">
  <ng-template #title>
    <div class="vote-head">
      <span class="vote-head__icon" [class.vote-head__icon--danger]="isDeny" aria-hidden="true">
        <i [class]="isDeny ? 'pi pi-times' : 'pi pi-check'"></i>
      </span>
      <div class="vote-head__texts">
        <p class="vote-head__eyebrow">Voto no comitê de crédito</p>
        <h4 class="vote-head__title">{{ heading }}</h4>
      </div>
    </div>
  </ng-template>

  <div class="vote-modal">
    <p class="vote-modal__text">{{ description }}</p>
    @if (text) {
      <div class="vote-modal__quote">{{ text }}</div>
    }
  </div>

  <ng-template #footer>
    <div class="vote-foot">
      <app-button
        [label]="'Voltar'"
        [theme]="'outline-grey'"
        [type]="'button'"
        (sendButtonClick)="close()"></app-button>
      <app-button
        [label]="confirmLabel"
        [icon]="isDeny ? 'times' : 'check'"
        [theme]="isDeny ? 'danger' : 'darkblue'"
        [type]="'button'"
        (sendButtonClick)="submitAction()"></app-button>
    </div>
  </ng-template>
</app-dialog>
